import React, {useRef, useEffect, useMemo} from 'react';
import {Platform, View} from 'react-native';
import Lottie from 'lottie-react-native';
import {RFValue} from 'react-native-responsive-fontsize';

interface Props {
  width?: number;
  height?: number;
  speed?: number;
  autoPlay?: boolean;
  loop?: boolean;
}

export function Baratinhaz({
  width,
  height,
  speed = 1,
  autoPlay = true,
  loop = true,
}: Props) {
  const lottieRef = useRef<Lottie>(null);
  const source = useMemo(
    () => require('../../../assets/images/json/Baratinhaz.json'),
    [],
  );
  useEffect(() => {
    if (autoPlay && lottieRef.current) {
      lottieRef.current.play();
    }
  }, [autoPlay]);

  return (
    <View style={{width: width ?? RFValue(16), height: height ?? RFValue(16)}}>
      {source && (
        <Lottie
          ref={lottieRef}
          // se você estiver trocando o JSON e não refletir no Android, mude esse sufixo:
          key="baratinhaz-v1"
          source={source}
          style={{width: '100%', height: '100%'}}
          autoPlay={autoPlay}
          loop={loop}
          speed={speed}
          cacheComposition={false}
          renderMode={Platform.OS === 'android' ? 'SOFTWARE' : 'AUTOMATIC'}
          enableMergePathsAndroidForKitKatAndAbove
          hardwareAccelerationAndroid
        />
      )}
    </View>
  );
}
